export const createOrdersQueryParams = (page, activeTab) => ({
    page: page - 1,
    size: 7,
    state: [activeTab],
    sortOrder: 'UPDATED_DESC',
    includeThankYouData: activeTab === 'SENT',
});
